import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { startRum } from "@/lib/rum";
import { startMobileTables } from "@/lib/mobileTables";

// A boutiqaat.com product photo that no longer loads (the product sold out and
// was disabled): show this server's copy of it instead (the daily "photos" job).
window.addEventListener(
  "error",
  (e) => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement) || img.dataset.ownCopy) return;
    const src = img.currentSrc || img.src || "";
    if (!src.includes("v2cdn.boutiqaat.com")) return;
    img.dataset.ownCopy = "1";
    img.removeAttribute("srcset");
    img.src = `${process.env.REACT_APP_BACKEND_URL || ""}/api/product-photo?u=${encodeURIComponent(src)}`;
  },
  true,
);

startRum();
startMobileTables();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
